import { useState } from 'react';

import { Labels } from '@/models/labels';

import { useLabelCatalog } from './useLabelCatalog';
import { usePendingLabel } from './usePendingLabel';
import { useSaveLabel } from './useSaveLabel';

export const usePostLabels = (postId: number, labels: Labels.Details[]) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const staging = usePendingLabel(labels);
  const catalog = useLabelCatalog(isPickerOpen, staging.isUnavailable);
  const { isSaving, handleSave } = useSaveLabel();

  const pendingCount = staging.pending.length + staging.removing.length;
  const pendingText =
    pendingCount === 0
      ? 'No pending changes'
      : `${pendingCount} pending ${
          pendingCount === 1 ? 'change' : 'changes'
        } - not saved yet`;

  return {
    isPickerOpen,
    setIsPickerOpen,
    inputValue,
    setInputValue,
    ...staging,
    ...catalog,
    isSaving,
    isActionDisabled: pendingCount === 0 || isSaving,
    pendingText,
    save: () =>
      handleSave({
        postId,
        labels,
        pending: staging.pending,
        removing: staging.removing,
        setPending: staging.setPending,
        setRemoving: staging.setRemoving
      }),
    discard: () => {
      staging.setPending([]);
      staging.setRemoving([]);
    }
  };
};
